module.exports = __webpack_public_path__ + "img/down-arrow-dark.svg";